import axios from "axios";
// import qs from "qs";
import store from '@/store'
import { Message, MessageBox } from 'element-ui'
import Cookies from 'js-cookie'

import {FedLogOut} from '../../store/user'
import {getToken} from "../../utils/auth";

const BASEURL = "http://116.63.141.215:9101"

//东北麦能学堂
// const BASEURL = "http://116.63.141.215:9201"

//本地测试
// const BASEURL = "http://127.0.0.1:9101"
// const BASEURL = "http://39.102.69.1:9109"
// const BASEURL = "http://39.102.68.11:9101"
let request = axios.create({
    baseURL: BASEURL,
    timeout: 60000,
});
// 创建 axios 实例

request.interceptors.request.use(
    (config) => {
        // console.log(config.url == "api/upload/upload")

        if(config.url == "api/upload/upload"){
            config.headers = {
                "Content-Type": "multipart/form-data"
            }
        }
        console.log("我是疯长token")
        console.log(getToken())
        config.headers['X-Token'] = getToken();
        config.headers['X-Front'] = "web_front"
        // config.headers.Authorization = store.get("token");
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

// 发送 请求拦截 添加 token 头信息
request.interceptors.response.use(
    (res) => {
        // 加载提示  301,401,403,404,505,
        if (res.data.code !== 200) {
            Message({
                message: res.data.message,
                type: 'error',
                duration: 5 * 1000
            })
            // 401:Token过期 或 未登录
            if (res.data.code === 401) {
                MessageBox.confirm('你已被登出，是否重新登录？', '提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        localStorage.clear()
                        location.reload() // 为了重新实例化vue-router对象 避免bug
                    }).catch( err =>{

                    })
                })
            }
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    (err) => {
        Message({
            message: err.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(err)
    }
);

export default request


// request.postURL = function (url, method = "get", data) {
//     const info = store.get("info");
//     let token = ''
//     let user_id = ''
//     if (store.get("info")) {
//         token = store.get('token')
//         user_id = info.id
//         // console.log(info.info.id)
//     }
//     return new Promise(function (resolve, reject) {
//         request({
//             url: url,
//             data: info ? {
//                 token,
//                 ...data
//             } : data,
//             method: method,
//
//         })
//             .then((res) => resolve(res.data))
//             .catch((err) => reject(err));
//     });
// };
// const get = (url, data) => {
//     return request.postURL(url, 'get', data)
// }
// const post = (url, data) => {
//     return request.postURL(url, 'post', data)
// }
// export default {
//     get,
//     post
// }

